import styled from 'styled-components';
import { OLAF } from 'HubStyleTokens/colors';
import { TABLE_BORDER_COLOR } from 'HubStyleTokens/theme';
import UITableHoverCell from 'UIComponents/table/UITableHoverCell';
import { useNumberOfFrozenColumns } from 'framework-listing-lib/internal/ViewTabs/hooks/useViewProps';
import { useListingLibBulkActions } from 'framework-listing-lib/internal/Table/providers/ListingLibBulkActionsProvider';

/**
 * Allows custom cells to specify position: absolute children relative to the cell itself
 */
import { jsx as _jsx } from "react/jsx-runtime";
const RelativeLabelCell = styled(UITableHoverCell).withConfig({
  displayName: "ListingLibLabelCell__RelativeLabelCell",
  componentId: "sc-12dx502-0"
})(["position:relative;"]);

/**
 * From https://git.hubteam.com/HubSpot/customer-data-table/blob/79c4edfd7d31cb1a5b67b0e9c4e3b5b0ba673536/framework-data-table/static-2.6311/js/contentRenderers/labels/LabelCell.tsx#L165-L173
 */
const StickyLabelCell = styled(UITableHoverCell).withConfig({
  displayName: "ListingLibLabelCell__StickyLabelCell",
  componentId: "sc-12dx502-1"
})(["&&&&{background-color:", ";border-right:4px solid ", ";left:0px;position:sticky;z-index:1;}"], OLAF, TABLE_BORDER_COLOR);
export default function ListingLibLabelCell(props) {
  const numberOfFrozenColumns = useNumberOfFrozenColumns();
  if (numberOfFrozenColumns && numberOfFrozenColumns > 0) {
    return /*#__PURE__*/_jsx(StickyListingLibLabelCellInner, Object.assign({}, props));
  }
  return /*#__PURE__*/_jsx(RelativeLabelCell, Object.assign({
    "data-sticky-cell": false,
    "data-test-id": "listing-lib-label-cell"
  }, props));
}
function StickyListingLibLabelCellInner(props) {
  const {
    hasBulkActions
  } = useListingLibBulkActions();
  return /*#__PURE__*/_jsx(StickyLabelCell, Object.assign({
    "data-sticky-cell": true,
    "data-test-id": "listing-lib-label-cell",
    style: hasBulkActions ? {
      left: 44
    } : undefined
  }, props));
}